<div class="">
	<div class="row">
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Support Request</div>
				<div class="content minimum">
					<p>Please submit your support request below. Your note will be sent to your designated support
						representative.</p>
					<div class="form-group">
						<textarea [(ngModel)]="requestContent" style="width: 100%;height: 250px;"></textarea>
					</div>
					<app-action-button [action]="SendRequest" [context]="this" processing="Sending..." complete="Request sent">
						Send Request</app-action-button>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Support Info</div>
				<div class="content minimum">
					<div *ngIf="primary" class="contact">
						<div class="contact-title">Primary Support</div>
						<div class="contact-name">{{primary.name}}</div>
						<div>{{primary.email}}</div>
						<div *ngIf="primary.phone">{{primary.phone}}</div>
					</div>
					<div *ngIf="secondary" class="contact">
						<div class="contact-title">Secondary Support</div>
						<div class="contact-name">{{secondary.name}}</div>
						<div>{{secondary.email}}</div>
						<div *ngIf="secondary.phone">{{secondary.phone}}</div>
					</div>
					<div *ngIf="knowledge && knowledge.length">
						<div class="contact-title">Knowledge Base</div>
						<div *ngFor="let entry of knowledge" class="contact">
							<a [href]="entry.url" target="_blank">{{entry.title}} <i class="icon-link-ext"></i></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>